/* eslint-disable */
import cls from 'classnames'
import * as React from 'react'
import { useModalContext } from '../modal'
import { ModalFocusScope } from '../modal-focus-scope/index'
import { ModalTransition } from '../utils/modal-transition'
import type * as Polymorphic from '../../../../react-utils/polymorphic'
import styles from './modal-content.module.css'

export interface ModalContentProps extends React.HTMLProps<any> {
  /**
   * The props to forward to the modal's content wrapper
   */
  containerProps?: any
  /**
   * ZIndex stuff for custom position on screen
   */
  zIndex?: string
  isCentered?: boolean
  modalWidth?: string
}

/**
 * ModalContent is used to group modal's content. It has all the
 * necessary `aria-*` properties to indicate that it is a modal
 */

export const ModalContent = React.forwardRef(
  (
    {
      className,
      children,
      modalWidth,
      zIndex,
      isCentered,
      containerProps: rootProps,
      ...rest
    },
    ref,
  ) => {
    const { getDialogProps, getDialogContainerProps } = useModalContext()

    const dialogProps = getDialogProps(rest, ref)
    const containerProps = getDialogContainerProps(rootProps)
    const _className = cls(styles.paypal_modal__content, className)

    const dialogStyles: React.CSSProperties = {
      position: 'relative',
      width: modalWidth ? modalWidth : '100%',
      outline: 0,
      opacity: 1,
      transform: 'none',
    }

    const dialogContainerStyles: any = {
      height: '-webkit-fill-available',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: zIndex,
    }

    const dialogContainerStylesCentered: any = {
      height: '-webkit-fill-available',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: zIndex,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }

    const { motionPreset } = useModalContext()

    return (
      <ModalFocusScope>
        <div
          {...containerProps}
          className={styles.paypal_modal__content_container}
          tabIndex={-1}
          style={
            isCentered ? dialogContainerStylesCentered : dialogContainerStyles
          }
        >
          <ModalTransition
            preset={motionPreset}
            className={_className}
            {...(dialogProps as any)}
            style={dialogStyles}
          >
            {children}
          </ModalTransition>
        </div>
      </ModalFocusScope>
    )
  },
) as Polymorphic.ForwardRefComponent<any, ModalContentProps>

ModalContent.displayName = 'ModalContent'
